













import Vue, { PropType } from "vue";

/* Sub-components */
import Dropdown from "../Dropdown/Dropdown.vue";

export default Vue.extend({
  components: {
    Dropdown,
  },
  props: {
    step: {
      type: Number as PropType<number>,
      required: true,
    },
    valid: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    tabindex: {
      type: String as PropType<string>,
      required: true,
    },
  },
});
